module.exports = __webpack_public_path__ + "static/media/glace.97ed4871.svg";